import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const Image = ({ remoteImage, fallbackImageUrl, alt }) => {
	const image = getImage(remoteImage)

	return (
		<div>
			{image ? (
				<GatsbyImage image={image} alt={alt} />
			) : (
				<img src={fallbackImageUrl} alt={alt} loading="lazy" />
			)}
		</div>
	)
}

export default Image
